export default class EstadosFiltros {
  constructor({ sigla = null, _embed = null } = {}) {
    this.sigla = sigla;
    this._embed = _embed;
  }
}
